import { createSelector } from "@ngrx/store";
import { appState } from "src/app/shared/interfaces/appState.interface";
import { Options } from "src/app/shared/interfaces/options.interface";

export const selectOptionsState = (state: appState) => state.options;

export const selectLastUpdate = createSelector(
  selectOptionsState,
  (options: Options) => options.lastUpdate
);

export const selectLastUpdateHasError = createSelector(
  selectOptionsState,
  (options: Options) => options.lastUpdateHasError
);

export const selectLocation = createSelector(
  selectOptionsState,
  (options: Options) => options.location
);